module.exports = __webpack_public_path__ + "img/jang.85a97319.png";